export class SIQSkipActionButtonTheme {
  textColor = "null";
  borderColor = "null";
  backgroundColor = "null";
  cornerRadius = null; // Int
}
//# sourceMappingURL=SIQSkipActionButtonTheme.js.map